<template>
  <div class="mx-3">
    <div>
      <ValidationObserver ref="messageObserver">
        <div class="additional-container">
          <div class="py-3 px-1 pl-c-xl">
            <icon-view
              icon="fas fa-info-circle"
              icon-background="transparent"
              icon-color="#FF7058"
              icon-size="1.0625rem"
              :title="sectionTitle"
              variant="custom-icon"
            />
          </div>
        </div>
        <div
          v-for="(item, index) in questionsData"
          :key="index"
          class="row mt-3 mb-4"
        >
          <div class="col-12 my-3 color-gray-6 font-16 text-justify">
            {{ item.question }}
          </div>
          <div class="col-12">
            <ValidationProvider
              v-slot="{ errors }"
              :custom-messages="{
                required: 'El comentario es requerido.',
              }"
              rules="required|hasValidCommentSizeFRB"
            >
              <span v-if="isReadOnly" class="data-content d-block text-justify">
                {{ item.answer | empty }}
              </span>
              <custom-text-area
                v-else
                v-model="item.answer"
                :count-classes="['float-right']"
                :disabled="isReadOnly"
                :error="errors[0]"
                :maxlength="3000"
                placeholder="Escribe un comentario"
                :prevent-enter="true"
                :show-char-count="!isReadOnly"
                @input="getComment(index, $event)"
              />
              <custom-error
                v-if="errors[0] && errors[0].length > 0"
                class="ml-3 my-2 no-border"
                :message="errors[0]"
                style="right: 15px; "
                variant="no-border"
              />
            </ValidationProvider>
          </div>
          <div v-if="isReadOnly" class="col-12">
            <hr />
          </div>
        </div>
        <div class="mt-3 mb-3 align-items-center d-flex justify-content-end">
          <action-button
            v-if="!isReadOnly"
            id="btnCancel"
            :disabled="isReadOnly"
            i="fas fa-times-circle"
            text="Cancelar"
            variant="outline-danger mr-3 pl-3 pr-4"
            @click="onCancel"
          />
          <action-button
            v-if="!isReadOnly"
            id="btnSave"
            i="fas fa-flag pr-2"
            text="Someter"
            variant="success px-3"
            @click="onSaveHandler"
          />
        </div>
        <div class="col-12">
          <custom-modal
            cancel-text="Cancelar"
            icon="fas fa-exclamation-circle"
            is-centered
            :save-icon="'fas fa-flag pr-2'"
            save-text="Someter"
            show-cancel
            show-save
            title="Someter"
            :value="showModal"
            width="850px"
            @cancel="onCancelAcceptTermHandler"
            @save="onSubmit"
          >
            <custom-checkbox-single-option
              id="custom-checkbox-acceptedTerms"
              v-model="acceptedTerms"
              class="font-16"
              option-text="Acepto los términos y responsabilidades"
              title="Certifico que la información ofrecida es cierta y correcta"
            />
          </custom-modal>
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import CustomTextArea from 'CustomTextArea';
import CustomError from 'custom-error';
import IconView from 'icon-view';
import ActionButton from 'ActionButton';
import CustomModal from 'CustomModal';
import CustomCheckboxSingleOption from 'custom-checkbox-single-option';
import {
  submitAnswer as _submitAnswer,
  updateStatus as _updateStatus,
} from '@/services/provider/provider-question.js';
import providerQuestionSection from '@/utils/constants/providerQuestionSection';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import providerProfileStates from '@/utils/constants/ProviderProfileStates';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

export default {
  name: 'FinancialResourcesBilling',
  components: {
    CustomTextArea,
    CustomError,
    IconView,
    ActionButton,
    CustomModal,
    CustomCheckboxSingleOption,
    ValidationObserver,
    ValidationProvider,
  },
  mixins: [alertMixin],
  async mounted() {
    if (
      [
        providerProfileStates.Submitted,
        providerProfileStates.Approved,
        providerProfileStates.Denied,
      ].includes(this.statusId)
    ) {
      if (this.questions && this.questions.length > 0) {
        this.questionsData = this.questions.map((item) => ({
          ...item,
          answer: item.answers?.[0]?.answer || '',
        }));
      }
    } else {
      this.questionsData = this.questions.map((item) => ({
        ...item,
        answer: '',
      }));
    }
  },
  data: () => ({
    questionsData: [],
    showModal: false,
    acceptedTerms: false,
  }),
  computed: {
    isReadOnly() {
      return (
        this.statusId == providerProfileStates.Submitted ||
        this.statusId == providerProfileStates.Approved
      );
    },
  },
  props: {
    providerId: {
      type: Number,
      default: () => 0,
    },
    statusId: {
      type: Number,
      default: () => 0,
    },
    sectionTitle: {
      type: String,
      default: () => '',
    },
    questions: {
      type: Array,
      default: () => [],
    },
    biddingAcademicYearId: {
      type: Number,
      default: () => 0,
    },
  },
  methods: {
    getComment(i, value) {
      this.questionsData[i].answer = value;
    },
    clean() {
      this.questionsData = [];
      this.showModal = false;
      this.acceptedTerms = false;
    },
    async onCancel() {
      const answer = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro de que desea cancelar? Si cancela, se borrarán todos los datos que ha llenado en esta sección.`,
        'Sí',
        'No'
      );

      if (answer) {
        this.clean();
        this.$emit('on-cancel');
      } else {
        return;
      }
    },
    async onSaveHandler() {
      const isValid = await this.$refs.messageObserver.validate();
      if (isValid) {
        this.showModal = true;
      } else {
        this.ShowToast('Alerta', 'Información Incompleta', 'error');
        return;
      }
    },
    async onCancelAcceptTermHandler() {
      this.showModal = false;
      this.acceptedTerms = false;
    },
    async onSubmit() {
      if (!this.acceptedTerms) {
        this.ShowToast(
          'Alerta',
          'Favor aceptar los términos y responsabilidades.',
          'error'
        );
        return;
      }

      const payload = {
        sectionId: providerQuestionSection.FinancialResourcesBilling,
        providerId: this.providerId,
        academicYearId: this.biddingAcademicYearId,
        statusId: providerProfileStates.Submitted,
        answers: this.questionsData
          .filter((item) => item.answer.trim() !== '')
          .map((item) => ({
            questionId: item.id,
            answer: item.answer,
          })),
      };

      const { data: response } = await _submitAnswer(payload);
      if (response) {
        this.ShowToast(
          'Confirmación',
          'El estatus ha sido actualizado exitosamente.',
          'success'
        );
        this.$emit('on-save');
      } else {
        this.ShowToast('Error', response?.data?.message || 'error', 'error');
      }

      this.showModal = false;
      this.acceptedTerms = false;
    },
    async onActionApproveDenyHandler(item, status) {
      const options = {
        [providerProfileStates.Approved]: ['aprobar', 'aprobado'],
        [providerProfileStates.Denied]: ['denegar', 'denegado'],
      };

      const answer = await this.ShowCancelModal(
        'Determinación',
        `¿Está seguro(a) que desea ${options[status][0]}?`,
        'Sí',
        'No'
      );
      if (!answer) return;

      const payload = {
        sectionId: item.id,
        providerId: this.providerId,
        academicYearId: this.biddingAcademicYearId,
        statusId: status,
      };

      const { data: response } = await _updateStatus(payload);
      if (response) {
        this.ShowToast(
          'Confirmación',
          `El estatus ha sido cambiado a ${options[status][1]} exitosamente.`,
          'success'
        );
        this.$emit('on-save');
      } else {
        this.ShowToast('Error', response?.data?.message || 'error', 'error');
      }
    },
    async onGoBackHandler(item) {
      const answer = await this.ShowCancelModal(
        'Determinación',
        `¿Está seguro(a) que desea regresar al estatus Sometido?`,
        'Sí',
        'No'
      );
      if (!answer) return;

      const payload = {
        sectionId: item.id,
        providerId: this.providerId,
        academicYearId: this.biddingAcademicYearId,
        statusId: providerProfileStates.Submitted,
      };

      const { data: response } = await _updateStatus(payload);

      if (response) {
        this.ShowToast(
          'Confirmación',
          'El estatus ha sido actualizado exitosamente.',
          'success'
        );
        this.$emit('on-save');
      } else {
        this.ShowToast('Error', response?.data?.message || 'error', 'error');
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .custom-icon {
  .dot {
    box-shadow: none !important;
    margin-right: 4px !important;
  }
  .dot.dot--has-border {
    border-color: transparent !important;
  }
  .color-gray-7.font-16.font-weight-bold {
    color: #11291b !important;
  }
}
</style>
